module.exports = __webpack_public_path__ + "officialStatic/fonts/Skia-Regular.82b7173.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/Skia-Regular.woff2
// module id = 4O24
// module chunks = 0